import { cva } from 'class-variance-authority';

export const cvaIcon = cva(['elements-cvaIcon', 'shrink-0'], {
  variants: {
    size: {
      xSmall: 'h-3 w-3',
      small: 'h-4 w-4',
      medium: 'h-5 w-5',
      default: 'h-6 w-6',
      large: 'h-8 w-8',
      xLarge: 'h-10 w-10',
      xxLarge: 'h-12 w-12',
    },
  },
  defaultVariants: {
    size: 'default',
  },
});

export const cvaScrollbar = cva(
  [
    'elements-cvaScrollbar',
    'scrollbar-thin scrollbar-w-1 scrollbar-track-transparent scrollbar-thumb-rounded-sm',
  ],
  {
    variants: {
      thumbColor: {
        default: 'scrollbar-thumb-general_background_MIII_400_dark',
        light: 'scrollbar-thumb-general_background_MIII_300_dark',
        dark: 'scrollbar-thumb-general_background_MIII_500_dark',
        primary: 'scrollbar-thumb-general_accent_MII_primary',
        secondary: 'scrollbar-thumb-general_text_MII_secondary_i',
      },
    },
    defaultVariants: {
      thumbColor: 'default',
    },
  },
);
